import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default async function editHotelLicence({ hotelId, licence }) {
  const {
    host,
    URIs: { editHotelLicence },
  } = apiConfig;

  const uri = `${host}${editHotelLicence}`.replace(':hotelLicenceId', licence.id);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  let typeExceptions = [
    'monthly',
    'bimonthly',
    'quarterly',
    'four_monthly',
    'biannual',
    'two_yearly',
  ];

  const data = {
    hotelId: hotelId || 0,
    hotelReference: 'civitfun',
    accessToken: storedCredentials.accessToken,
    name: licence.name,
    contractId: licence.contractId,
    currency: licence.currency,
    price: licence.price,
    billingDate: licence.billingDate,
  };

  // FIXME: temporal patch
  if (!typeExceptions.includes(licence.type)) {
    data.type = licence.type;
  }

  return axios
    .put(uri, {
      data,
    })
    .then(res => {
      return res.data;
    });
}
